(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-before-after-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bas]').forEach(function (stage) {
    var range = stage.querySelector('[data-bas-range]');
    if (!range) return;
    function update() { stage.style.setProperty('--pos', range.value + '%'); }
    range.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-collection-swipe"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.brand-cs').forEach(function (sec) {
    var track = sec.querySelector('[data-cs-track]');
    var nav = sec.querySelector('[data-cs-nav]');
    if (track && nav) {
      if (track.scrollWidth > track.clientWidth + 8) nav.hidden = false;
      var step = function (dir) {
        var card = track.querySelector('.brand-cs__card');
        var amount = card ? card.offsetWidth + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      };
      var p = sec.querySelector('[data-cs-prev]'); if (p) p.addEventListener('click', function () { step(-1); });
      var n = sec.querySelector('[data-cs-next]'); if (n) n.addEventListener('click', function () { step(1); });

      /* Trackpad guard: if a gesture is mostly vertical, let the page scroll
         instead of the carousel hijacking it. */
      track.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { return; }
        if (e.cancelable) { e.stopPropagation(); }
      }, { passive: true });
    }
  });

  document.querySelectorAll('[data-cs-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.hasAttribute('disabled')) return;
      var label = btn.getAttribute('data-add-label') || btn.textContent;
      btn.setAttribute('disabled', '');
      btn.textContent = 'Adding...';
      var routes = window.routes || {};
      fetch((routes.cart_add_url || '/cart/add'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) { btn.textContent = 'Unavailable'; setTimeout(function () { btn.textContent = label; btn.removeAttribute('disabled'); }, 1600); return; }
        var cd = document.querySelector('cart-drawer');
        var cn = document.querySelector('cart-notification');
        if (cd && typeof cd.renderContents === 'function') { cd.renderContents(res); }
        else if (cn && typeof cn.renderContents === 'function') { cn.renderContents(res); }
        else { document.dispatchEvent(new CustomEvent('cart:refresh')); }
        document.dispatchEvent(new CustomEvent('cart:added'));
        btn.textContent = 'Added';
        setTimeout(function () { btn.textContent = label; btn.removeAttribute('disabled'); }, 1600);
      }).catch(function () { window.location = (routes.cart_url || '/cart'); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-countdown"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('[data-countdown]').forEach(function (sec) {
      var endStr = sec.dataset.end;
      var end = endStr ? new Date(endStr.replace(' ', 'T')).getTime() : NaN;
      if (isNaN(end)) return;
      var timer = sec.querySelector('[data-cd-timer]');
      var expired = sec.querySelector('[data-cd-expired]');
      var d = sec.querySelector('[data-cd-days]'), h = sec.querySelector('[data-cd-hours]'),
          m = sec.querySelector('[data-cd-mins]'), s = sec.querySelector('[data-cd-secs]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      var iv = setInterval(tick, 1000);
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          clearInterval(iv);
          if (sec.dataset.onExpire === 'hide') { sec.hidden = true; return; }
          if (timer) timer.hidden = true;
          if (expired) expired.hidden = false;
          return;
        }
        var sct = Math.floor(diff / 1000);
        d.textContent = pad(Math.floor(sct / 86400));
        h.textContent = pad(Math.floor((sct % 86400) / 3600));
        m.textContent = pad(Math.floor((sct % 3600) / 60));
        s.textContent = pad(sct % 60);
      }
      tick();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-counter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-counter]').forEach(function (root) {
    var nums = root.querySelectorAll('[data-counter-num]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    function run(el) {
      var target = parseFloat(el.dataset.target);
      if (isNaN(target)) return;
      var decimals = (el.dataset.target.split('.')[1] || '').length;
      var start = null, dur = 1400;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(decimals);
      }
      el.textContent = (0).toFixed(decimals);
      requestAnimationFrame(step);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-faq]').forEach(function (ui) {
    var tabs = ui.querySelectorAll('[data-faq-tab]');
    var panels = ui.querySelectorAll('[data-faq-panel]');
    if (!tabs.length) return;
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-faq-tab');
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-faq-panel') === i); });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-featured-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fp-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-fp-slide]');
    var thumbs = gallery.querySelectorAll('[data-fp-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = thumb.dataset.fpThumb;
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.fpSlide === i); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  });

  document.querySelectorAll('[data-fp-options]').forEach(function (fieldset) {
    var form = fieldset.closest('form');
    var planInput = form && form.querySelector('[data-fp-plan]');
    var options = fieldset.querySelectorAll('[data-fp-option]');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        var radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        options.forEach(function (o) { o.classList.toggle('is-selected', o === opt); });
        if (planInput) planInput.value = opt.getAttribute('data-plan') || '';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hslide]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-hslide-slide]');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-hslide-dot]');
    var i = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === i);
        if (idx === i) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }
    function next() { show(i + 1); }
    function start() {
      if (reduce || root.dataset.autoplay !== 'true') return;
      stop();
      timer = setInterval(next, (parseFloat(root.dataset.interval) || 5) * 1000);
    }
    function stop() { if (timer) clearInterval(timer); }
    var prev = root.querySelector('[data-hslide-prev]'); if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    var nx = root.querySelector('[data-hslide-next]'); if (nx) nx.addEventListener('click', function () { show(i + 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.dataset.hslideDot, 10)); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ing]').forEach(function (root) {
    var shots = root.querySelectorAll('[data-ing-shot]');
    var tabs = [].slice.call(root.querySelectorAll('[data-ing-tab]'));
    var nameEl = root.querySelector('[data-ing-name]');
    var benEl = root.querySelector('[data-ing-benefit]');
    if (!tabs.length) return;
    function show(i) {
      shots.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-ing-shot') === String(i)); });
      tabs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      var t = tabs[i];
      if (nameEl) nameEl.textContent = t.getAttribute('data-name') || '';
      if (benEl) benEl.textContent = t.getAttribute('data-benefit') || '';
    }
    tabs.forEach(function (t, idx) {
      t.addEventListener('mouseenter', function () { show(idx); });
      t.addEventListener('click', function () { show(idx); });
      t.addEventListener('focus', function () { show(idx); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-product-main"]) return;
  try {
    
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-slide]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');

    function playVideo(v) {
      if (!v) return;
      var attempt = v.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    }

    function show(index) {
      slides.forEach(function (s) {
        var on = s.dataset.slide === String(index);
        s.classList.toggle('is-active', on);
        var v = s.querySelector('video');
        if (v) {
          if (on) { playVideo(v); } else { v.pause(); }
        }
      });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(index)); });
    }

    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { show(thumb.dataset.thumb); }); });

    /* If the gallery opens on a video, start it. */
    playVideo(gallery.querySelector('.brand-pdp__slide.is-active video'));

    /* Pause everything once the gallery scrolls out of view, resume the
       active slide when it comes back. Saves battery and data on mobile. */
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var active = gallery.querySelector('.brand-pdp__slide.is-active video');
          if (e.isIntersecting) { playVideo(active); }
          else { gallery.querySelectorAll('video').forEach(function (v) { v.pause(); }); }
        });
      }, { threshold: 0.15 });
      vio.observe(gallery);
    }
  });

  // Tier selector: keep the form's variant + selling_plan in sync with the
  // selected tier. Inputs are re-found on EVERY apply because Seal
  // Subscriptions replaces the theme's selling_plan input at runtime, and the
  // selected tier is re-applied on submit (capture) so the right variant and
  // selling plan always reach the cart.
  document.querySelectorAll('[data-tiers]').forEach(function (tiers) {
    var form = tiers.closest('form');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var defaultVariant = tiers.getAttribute('data-default-variant');
    var tierEls = [].slice.call(tiers.querySelectorAll('[data-tier]'));
    function applyInputs(tier) {
      if (!form || !tier) return;
      var v = form.querySelector('[data-tier-variant]') || form.querySelector('input[name="id"]');
      if (v) v.value = tier.getAttribute('data-variant') || defaultVariant;
      var plans = form.querySelectorAll('input[name="selling_plan"]');
      for (var i = 0; i < plans.length; i++) plans[i].value = tier.getAttribute('data-plan') || '';
    }
    function select(tier) {
      tierEls.forEach(function (t) {
        var on = t === tier;
        t.classList.toggle('is-selected', on);
        var r = t.querySelector('input[type="radio"]');
        if (r) r.checked = on;
      });
      applyInputs(tier);
      if (stickyPrice && tier.getAttribute('data-price')) stickyPrice.textContent = tier.getAttribute('data-price');
    }
    tierEls.forEach(function (t) { t.addEventListener('click', function () { select(t); }); });
    var pre = tiers.querySelector('[data-tier].is-selected') || tierEls[0];
    if (pre) select(pre);
    if (form) {
      form.addEventListener('submit', function () {
        applyInputs(tiers.querySelector('[data-tier].is-selected'));
      }, true);
    }
    /* re-apply after app scripts (Seal) have swapped inputs on load */
    setTimeout(function () { applyInputs(tiers.querySelector('[data-tier].is-selected')); }, 1500);
    setTimeout(function () { applyInputs(tiers.querySelector('[data-tier].is-selected')); }, 4000);
  });

  // Reveal sticky mobile ATC after the in-column button scrolls out of view
  (function () {
    var atc = document.querySelector('.brand-pdp__atc');
    var bar = document.querySelector('[data-sticky-bar]');
    if (!atc || !bar || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
    }, { rootMargin: '0px 0px -120px 0px' });
    io.observe(atc);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-reasons"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.brand-reasons').forEach(function (sec) {
    var track = sec.querySelector('[data-reasons-track]');
    var nav = sec.querySelector('[data-reasons-nav]');
    if (!track || !nav) return;
    if (track.scrollWidth > track.clientWidth + 8) nav.hidden = false;
    function step(dir) { var card = track.querySelector('.brand-reasons__card'); var amt = card ? card.offsetWidth + 16 : track.clientWidth * 0.8; track.scrollBy({ left: dir * amt, behavior: 'smooth' }); }
    var p = sec.querySelector('[data-reasons-prev]'); if (p) p.addEventListener('click', function () { step(-1); });
    var n = sec.querySelector('[data-reasons-next]'); if (n) n.addEventListener('click', function () { step(1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-routine-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-quiz]').forEach(function (quiz) {
    var intro = quiz.querySelector('[data-quiz-step="intro"]');
    var result = quiz.querySelector('[data-quiz-step="result"]');
    var questions = Array.prototype.slice.call(quiz.querySelectorAll('[data-quiz-step="q"]'));
    var current = -1;

    function showOnly(el) {
      intro.hidden = el !== intro;
      result.hidden = el !== result;
      questions.forEach(function (q) { q.hidden = q !== el; });
    }
    function goTo(index) {
      current = index;
      if (index < 0) { showOnly(intro); return; }
      if (index >= questions.length) { showOnly(result); return; }
      showOnly(questions[index]);
      var firstOpt = questions[index].querySelector('.brand-quiz__option');
      if (firstOpt) firstOpt.focus();
    }

    var startBtn = quiz.querySelector('[data-quiz-start]');
    if (startBtn) startBtn.addEventListener('click', function () { goTo(0); });

    questions.forEach(function (q, i) {
      q.querySelectorAll('[data-quiz-next]').forEach(function (btn) {
        btn.addEventListener('click', function () { goTo(i + 1); });
      });
      var back = q.querySelector('[data-quiz-back]');
      if (back) back.addEventListener('click', function () { goTo(i - 1); });
    });

    var restart = quiz.querySelector('[data-quiz-restart]');
    if (restart) restart.addEventListener('click', function () { goTo(-1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-seasonal-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.brand-seasonal__wrap').forEach(function (wrap) {
    var track = wrap.querySelector('[data-seasonal-track]');
    if (!track) return;
    function step(dir) {
      var card = track.querySelector('.brand-seasonal__slide');
      var amt = card ? card.offsetWidth + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amt, behavior: 'smooth' });
    }
    var p = wrap.querySelector('[data-seasonal-prev]'); if (p) p.addEventListener('click', function () { step(-1); });
    var n = wrap.querySelector('[data-seasonal-next]'); if (n) n.addEventListener('click', function () { step(1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tabs]').forEach(function (ui) {
    var tabs = ui.querySelectorAll('[data-tab]');
    var panels = ui.querySelectorAll('[data-panel]');
    function activate(index) {
      tabs.forEach(function (t) {
        var on = t.dataset.tab === String(index);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === String(index)); });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.dataset.tab); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.brand-ts').forEach(function (sec) {
    var track = sec.querySelector('[data-ts-track]');
    var nav = sec.querySelector('[data-ts-nav]');
    if (!track || !nav) return;
    if (track.scrollWidth > track.clientWidth + 8) nav.hidden = false;
    function step(dir) {
      var card = track.querySelector('.brand-ts__card');
      var amount = card ? card.offsetWidth + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    sec.querySelector('[data-ts-prev]').addEventListener('click', function () { step(-1); });
    sec.querySelector('[data-ts-next]').addEventListener('click', function () { step(1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.brand-vts').forEach(function (sec) {
    var track = sec.querySelector('[data-vts-track]');
    function step(dir) {
      var card = track.querySelector('.brand-vts__card');
      var amt = card ? card.offsetWidth + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amt, behavior: 'smooth' });
    }
    var p = sec.querySelector('[data-vts-prev]'); if (p) p.addEventListener('click', function () { step(-1); });
    var n = sec.querySelector('[data-vts-next]'); if (n) n.addEventListener('click', function () { step(1); });
  });
  document.querySelectorAll('.brand-vts [data-video]').forEach(function (wrap) {
    var btn = wrap.querySelector('[data-video-play]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var mp4 = wrap.dataset.mp4, embed = wrap.dataset.embed, el;
      if (embed) {
        var src = embed;
        if (embed.indexOf('youtube.com/watch?v=') > -1) { src = 'https://www.youtube.com/embed/' + embed.split('v=')[1].split('&')[0] + '?autoplay=1'; }
        else if (embed.indexOf('youtu.be/') > -1) { src = 'https://www.youtube.com/embed/' + embed.split('youtu.be/')[1].split('?')[0] + '?autoplay=1'; }
        else if (embed.indexOf('vimeo.com/') > -1 && embed.indexOf('player.') === -1) { src = 'https://player.vimeo.com/video/' + embed.split('vimeo.com/')[1].split('?')[0] + '?autoplay=1'; }
        el = document.createElement('iframe'); el.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture'); el.setAttribute('allowfullscreen', ''); el.src = src;
      } else if (mp4) {
        el = document.createElement('video'); el.src = mp4; el.controls = true; el.playsInline = true; el.autoplay = true;
      }
      if (el) { wrap.innerHTML = ''; wrap.appendChild(el); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video]').forEach(function (wrap) {
    var btn = wrap.querySelector('[data-video-play]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var mp4 = wrap.dataset.mp4;
      var embed = wrap.dataset.embed;
      var el;
      if (embed) {
        var src = embed;
        if (embed.indexOf('youtube.com/watch?v=') > -1) { src = 'https://www.youtube.com/embed/' + embed.split('v=')[1].split('&')[0] + '?autoplay=1'; }
        else if (embed.indexOf('youtu.be/') > -1) { src = 'https://www.youtube.com/embed/' + embed.split('youtu.be/')[1].split('?')[0] + '?autoplay=1'; }
        else if (embed.indexOf('vimeo.com/') > -1 && embed.indexOf('player.') === -1) { src = 'https://player.vimeo.com/video/' + embed.split('vimeo.com/')[1].split('?')[0] + '?autoplay=1'; }
        el = document.createElement('iframe');
        el.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        el.setAttribute('allowfullscreen', '');
        el.src = src;
      } else if (mp4) {
        el = document.createElement('video');
        el.src = mp4;
        el.controls = true;
        el.playsInline = true;
        el.autoplay = true; // only after the explicit click
      }
      if (el) { wrap.innerHTML = ''; wrap.appendChild(el); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-your-routine"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-routine]').forEach(function (root) {
    var track = root.querySelector('[data-routine-track]');
    var sw = root.querySelector('[data-routine-swtrack]');
    var pname = root.querySelector('[data-routine-name]');
    var pdesc = root.querySelector('[data-routine-desc]');
    var callout = root.querySelector('[data-routine-callout]');
    var steps = [].slice.call(root.querySelectorAll('[data-routine-step]'));
    if (steps.length < 1 || !track) return;
    var n = steps.length, pct = 100 / n, cur = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(i) {
      cur = i;
      var x = 'translateX(-' + (i * pct) + '%)';
      track.style.transform = x;
      if (sw) sw.style.transform = x;
      var b = steps[i];
      if (pname) pname.textContent = b.getAttribute('data-name') || '';
      if (pdesc) pdesc.textContent = b.getAttribute('data-desc') || '';
      if (callout) { callout.classList.remove('is-swap'); void callout.offsetWidth; callout.classList.add('is-swap'); }
      steps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (reduce || root.getAttribute('data-autoplay') !== 'true' || n < 2) return;
      stop();
      timer = setInterval(function () { go((cur + 1) % n); }, (parseFloat(root.getAttribute('data-interval')) || 4) * 1000);
    }
    function reset() { if (timer) { stop(); start(); } }

    steps.forEach(function (s, idx) {
      s.addEventListener('mouseenter', function () { go(idx); reset(); });
      s.addEventListener('click', function () { go(idx); reset(); });
      s.addEventListener('focus', function () { go(idx); });
    });

    root.querySelectorAll('[data-routine-play]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = btn.getAttribute('data-video');
        if (!url) return;
        var v = document.createElement('video');
        v.src = url; v.controls = true; v.playsInline = true; v.autoplay = true;
        v.className = 'brand-yr__video';
        btn.parentNode.appendChild(v);
        btn.remove();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    go(0);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mu-video-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(sec) {
      if (sec.__muVidsReady) return;
      sec.__muVidsReady = true;

      /* Move into the product buy box, under the trust line.
         Only the inner <section> is moved: a .shopify-section wrapper must stay
         a top level element, so the now empty wrapper is collapsed instead. */
      if (sec.getAttribute('data-placement') === 'inside') {
        var info = document.querySelector('.brand-pdp__info');
        if (info && sec.parentNode !== info) {
          var wrapper = sec.closest('.shopify-section');
          var trust = info.querySelector('.brand-pdp__trust');
          if (trust && trust.nextSibling) { info.insertBefore(sec, trust.nextSibling); }
          else { info.appendChild(sec); }
          if (wrapper && !wrapper.querySelector('[data-mu-vids]')) {
            wrapper.style.display = 'none';
            wrapper.style.margin = '0';
            wrapper.style.padding = '0';
          }
        }
      }

      var track = sec.querySelector('[data-vtrack]');
      if (!track) return;

      function pauseAll(except) {
        sec.querySelectorAll('video').forEach(function (v) {
          if (v !== except) {
            v.pause();
            v.controls = false;
            v.muted = true;
            var c = v.closest('.mu-vids__card');
            if (c) c.classList.remove('is-playing');
          }
        });
      }

      sec.querySelectorAll('.mu-vids__card').forEach(function (card) {
        var video = card.querySelector('video');
        var playBtn = card.querySelector('[data-vplay]');
        if (!video || !playBtn) return;
        playBtn.addEventListener('click', function () {
          pauseAll(video);
          card.classList.add('is-playing');
          video.muted = false;
          video.controls = true;
          video.play();
        });
        video.addEventListener('pause', function () {
          if (video.seeking) return;
          card.classList.remove('is-playing');
          video.controls = false;
        });
        video.addEventListener('ended', function () {
          card.classList.remove('is-playing');
          video.controls = false;
        });
      });

      function step(dir) {
        var card = track.querySelector('.mu-vids__card');
        var amount = card ? (card.offsetWidth + 8) * 2 : track.clientWidth * 0.6;
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      var prev = sec.querySelector('[data-vprev]');
      var next = sec.querySelector('[data-vnext]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    }

    function init() { document.querySelectorAll('[data-mu-vids]').forEach(setup); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:select', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
